var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.15 3.25H4.4a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3.75a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75m8.25 0h-3.75a.75.75 0 0 0-.75.75v2.25c0 .414.336.75.75.75h3.75a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75m0 6.75h-3.75a.75.75 0 0 0-.75.75V16c0 .414.336.75.75.75h3.75a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75m-8.25 3H4.4a.75.75 0 0 0-.75.75V16c0 .414.336.75.75.75h3.75A.75.75 0 0 0 8.9 16v-2.25a.75.75 0 0 0-.75-.75"
  })));
};
export default SvgGallery;